import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    iconWarning: {
        color: 'red',
        height: '32px',
        width: '34px',
        verticalAlign: 'middle',
        borderRadius: 5,
        border: 'none',
        outline: 'none',
        cursor: 'pointer'
    },
    container: {
        'display': 'flex',
        'gap': '0.6rem',
        'alignItems': 'center',
        'paddingLeft': '10px',
        '& div': { paddingBottom: 0 },
        '& div div div': {
            backgroundColor: '#f47920',
            color: '#fff',
            boxShadow: 'unset',
            borderRadius: 5,
            minWidth: 120,
        },
        '& div div div div': {
            '&:focus': {
                height: 28,
            }
        },
        '& div div div svg': {
            color: '#fff'
        },
    },
    containerDisabled: {
        '& div div div': {
            backgroundColor: '#aaaaaa'
        }
    }
});
